import { graphql } from '@/graphql-setup'

export const DRIVER_WORK_YEAR_QUERY = graphql(`
  query DriverWorkYear($year: Int!, $ownedVehiclesOnly: Boolean) {
    driverWorkYear(year: $year, ownedVehiclesOnly: $ownedVehiclesOnly) {
      user {
        id
        fullName
      }
      totalHours
      driveHours
      workHours
      availableHours
      days
      weeks
      months {
        month
        totalHours
        driveHours
        workHours
        availableHours
        days
      }
      weekTotals {
        weekStart
        totalHours
        driveHours
        workHours
        availableHours
        days
      }
    }
  }
`)

export const DRIVER_WORK_WEEKS_QUERY = graphql(`
  query DriverWorkWeeks($user: ID!, $year: Int!, $ownedVehiclesOnly: Boolean) {
    driverWorkWeeks(
      user: $user
      year: $year
      ownedVehiclesOnly: $ownedVehiclesOnly
    ) {
      weekStart
      isoWeek
      totalHours
      driveHours
      workHours
      availableHours
      days
    }
  }
`)

export const DRIVER_WORK_DAYS_QUERY = graphql(`
  query DriverWorkDays(
    $user: ID!
    $weekStart: Date!
    $year: Int
    $ownedVehiclesOnly: Boolean
  ) {
    driverWorkDays(
      user: $user
      weekStart: $weekStart
      year: $year
      ownedVehiclesOnly: $ownedVehiclesOnly
    ) {
      date
      totalHours
      driveHours
      workHours
      availableHours
      firstStart
      lastEnd
    }
  }
`)

export const DRIVER_OVERTIME_YEAR_QUERY = graphql(`
  query DriverOvertimeYear($year: Int!, $ownedVehiclesOnly: Boolean) {
    driverOvertimeYear(year: $year, ownedVehiclesOnly: $ownedVehiclesOnly) {
      weekLimitHours
      dayLimitHours
      dailyRestHours
      rows {
        user {
          id
          fullName
        }
        workingHours
        dayOvertimeHours
        weekOvertimeHours
        overtimeHours
        weeksWithOvertime
        daysWithOvertime
      }
    }
  }
`)

export const DRIVER_OVERTIME_WEEKS_QUERY = graphql(`
  query DriverOvertimeWeeks(
    $user: ID!
    $year: Int!
    $ownedVehiclesOnly: Boolean
  ) {
    driverOvertimeWeeks(
      user: $user
      year: $year
      ownedVehiclesOnly: $ownedVehiclesOnly
    ) {
      weekStart
      isoWeek
      workingHours
      dayOvertimeHours
      weekOvertimeHours
      overtimeHours
      days {
        start
        end
        workingHours
        overtimeHours
      }
    }
  }
`)
